import * as React from "react";
import type { SVGProps } from "react";
const SvgFittedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M3.36 1.68a.56.56 0 1 0 0 1.12v3.826a.6.6 0 0 0 0 .183V25.2a.559.559 0 0 0-.401.959.56.56 0 0 0 .401.161h21.28a.562.562 0 0 0 .525-.776.56.56 0 0 0-.525-.344V2.8a.56.56 0 1 0 0-1.12H3.36M4.48 2.8h5.6v3.36h-5.6zm6.72 0h7.84v22.4H11.2V6.814a.6.6 0 0 0 0-.183zm8.96 0h3.36v22.4h-3.36zM4.48 7.28h2.24v1.913c-.62.248-1.12.743-1.12 1.447v7.28a.56.56 0 0 0 .56.56H8.4a.56.56 0 0 0 .56-.56v-7.28c0-.704-.5-1.199-1.12-1.447V7.28h2.24v12.88H6.16a.56.56 0 0 0-.56.56v2.24H4.48zm2.784 2.807h.033c.307.011.543.244.543.553v6.72H6.72v-6.72c0-.31.237-.544.544-.553m5.607 2.225a.56.56 0 0 0-.551.568v2.24a.558.558 0 0 0 .776.525.56.56 0 0 0 .344-.525v-2.24a.56.56 0 0 0-.569-.568m8.96 0a.56.56 0 0 0-.551.568v2.24a.558.558 0 0 0 .776.525.56.56 0 0 0 .344-.525v-2.24a.56.56 0 0 0-.569-.568M6.72 21.28h3.36v1.68H6.72zm-2.24 2.8h5.6v1.12h-5.6z"
    />
  </svg>
);
export default SvgFittedIcon;
